export const WorkCommitteeList = [
  '学术工作委员会',
  '科普工作委员会',
  '咨询工作委员会',
  '组织工作委员会',
  '教育委员会',
  '青年工作委员会',
  '青少年工作委员会',
  '产学研用促进中心',
];
export const SpecialtyCommitteeList = [
  '计算机视觉专业委员会',
  '自然语言处理专委会',
  '人工智能专业委员会',
  '生物信息学专业委员会',
  '协同与信息服务专业委员会',
  '存储专业委员会',
  '网络专业委员会',
  '多媒体专业委员会',
  '系统结构专业委员会',
  '软件工程专业委员会',
  '物联网专业委员会',
  '信息安全专业委员会',
  '理论计算机科学专业委员会',
  '普适计算与嵌入式专业委员会',
  '数据库专业委员会',
  '教育信息化专业委员会',
  '高性能计算专业委员会',
  '金融科技专业委员会（筹）',
];
